module.exports = "https://img.xiyuyouxi.com/saas/img/avatar_val.0bfd4809.png";